import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useUserListBankAccount } from './hooks';
import { convertToPresentationProps } from './logics';
import { UserListBankAccountPresentation } from './presentations';
import { UserListBankAccountEmptyPresentation } from './presentations/empty';

/**
 * 利用者一覧（BankAccount）Container
 *
 * - 状態管理・アクションは useUserListBankAccount に委譲する
 * - API 型 → Presentation 型の変換は convertToPresentationProps に委譲する
 * - Empty / 通常表示の出し分けは isEmpty フラグで行う（三項演算子）
 * - 検索条件あり × 0 件のときは Empty を表示せず検索フォーム＋テーブルを表示する（PEN-309 対応パターン）
 *
 * NOTE: 親コンポーネント（Screen）で Suspense にラップすること
 */
export const UserListBankAccount: React.FC = () => {
  const {
    state: {
      usersData,
      bankAccountsData,
      totalPage,
      totalCount,
      currentPage,
      fullNameValue,
      emailValue,
      clientNameValue,
      isFiltered,
    },
    actions: {
      handlePageChange,
      handleRowClick,
      handleDeleteUser,
      handleEditUser,
      handleFilterChange,
      handleSearch,
      handleReset,
      handleDownloadCsv,
      isDownloadingCsv,
    },
  } = useUserListBankAccount();

  const { rows, isEmpty } = convertToPresentationProps({
    usersData,
    bankAccountsData,
    isFiltered,
  });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows,
    onPageChange: handlePageChange,
  });

  return isEmpty ? (
    <UserListBankAccountEmptyPresentation />
  ) : (
    <UserListBankAccountPresentation
      rows={rows}
      onEditUser={handleEditUser}
      onDeleteUser={handleDeleteUser}
      onRowClick={handleRowClick}
      pagerProps={pagerProps}
      fullNameValue={fullNameValue}
      emailValue={emailValue}
      clientNameValue={clientNameValue}
      onFullNameChange={handleFilterChange('full_name')}
      onEmailChange={handleFilterChange('email')}
      onClientNameChange={handleFilterChange('client_name')}
      onSearch={handleSearch}
      onReset={handleReset}
      onDownloadCsv={handleDownloadCsv}
      isDownloadingCsv={isDownloadingCsv}
    />
  );
};
